import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";
import { ReactComponent as SVG1 } from "images/svg/smartUrls.svg";
import { ReactComponent as SVG2 } from "images/svg/addSocialMedia.svg";
import { ReactComponent as SVG3 } from "images/svg/shareAcross.svg";
const HowItWorks = () => {
  return (
    <Container>
      <Typography
        align="center"
        size="3.6rem"
        weight="semibold"
        mb="2"
        m_size="4xl"
      >
        How Does RAted Fans Work?
      </Typography>
      <Typography align="center" size="2xl" color="#4E4E4E" mb="10" m_size="lg">
        Best Smart-Link Experience
      </Typography>
      <Grid>
        <GridItem>
          <Typography size="4rem" weight="bold" mb="3" m_size="3xl">
            Create Smart URLs and Presave Links
          </Typography>
          <Typography size="lg" lh="2.5" color={Colors.grey400} mb="3">
            Set up custom Smart URLs that link directly to your music or videos
            across multiple platforms like Spotify, Apple Music, and YouTube
            Music. You can also create Presave links to promote upcoming
            releases, allowing fans to automatically save your music on their
            preferred platform before it’s live.
          </Typography>
          <ButtonContainer>
            <PrimaryButton
              text="Create Links"
              icon={<Arrow color="#131313" />}
              inset
              iconPosition="right"
              iconSize="2"
            />
          </ButtonContainer>
        </GridItem>
        <GridItem>
          <SVG1 />
        </GridItem>
        <GridItem>
          <SVG2 />
        </GridItem>
        <GridItem>
          <Typography size="4rem" weight="bold" mb="3" m_size="3xl">
            Add Social Media Links
          </Typography>
          <Typography size="lg" lh="2.5" color={Colors.grey400} mb="3">
            Easily integrate your social media accounts into your Smart URLs.
            Fans can follow you on platforms like Instagram, Twitter, and
            Facebook right from the same link they use to access your music.
            This helps keep fans connected to your updates and content, driving
            interaction beyond just your music.
          </Typography>
          <ButtonContainer>
            <PrimaryButton
              text="Get Started"
              icon={<Arrow color="#131313" />}
              inset
              iconPosition="right"
              iconSize="2"
            />
          </ButtonContainer>
        </GridItem>
        <GridItem>
          <Typography size="4rem" weight="bold" mb="3" m_size="3xl">
            Share Across Platforms
          </Typography>
          <Typography size="lg" lh="2.5" color={Colors.grey400} mb="3">
            Promote your music, videos, and social profiles through a single,
            shareable URL. Whether through Instagram, Twitter, email, or your
            website, this all-in-one link makes it easy for fans to access your
            content, no matter where they find you
          </Typography>
          <ButtonContainer>
            <PrimaryButton
              text="Try it Now"
              icon={<Arrow color="#131313" />}
              inset
              iconPosition="right"
              iconSize="2"
            />
          </ButtonContainer>
        </GridItem>
        <GridItem>
          <SVG3 />
        </GridItem>
      </Grid>
    </Container>
  );
};

export default HowItWorks;

const Container = styled.div`
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 40% 40%;
  align-items: center;
  justify-content: space-between;
  grid-row-gap: 2.4rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    & :nth-child(3) {
      order: 4;
    }
    & :nth-child(4) {
      order: 3;
    }
    & :nth-child(5) {
      order: 5;
    }
    & :nth-child(6) {
      order: 6;
    }
  }
`;

const GridItem = styled.div`
  width: 100%;
`;

const ButtonContainer = styled.div`
  width: fit-content;
`;
